export const LOGIN_ERROR_MESSAGES: Record<LoginErrorCode, string> = {
    state: 'Your login expired or was started in another tab. Please try again.',
    team: 'Only members of the Yipp Slack workspace can log in.',
    failed: 'Logging in with Slack failed. Please try again.',
}
